import React from "react";
import Frequent from "../../reusable/Frequent";
import OneTime from "../../reusable/OneTime";

class Traveller extends React.Component {
  render() {
    return (
      <section className="mighty-benefits get-wifi-us-content">
        <div className="container">
          <div className="row">
            <Frequent />
            <OneTime />
          </div>
        </div>
      </section>
    );
  }
}

export default Traveller;



// WEBPACK FOOTER //
// ./src/pages/getwifiglobal/Traveller.js